module.exports = __webpack_public_path__ + "static/img/move2.3d306f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/connect/move2.png
// module id = jbsS
// module chunks = 7